/**
 * Workflow status values for a PLI configuration.
 *
 * The backend stores `pliStatus` using the shared calculation-status strings
 * (com.amazon.ictpe.dataaccess.util.Constants.CalculationStatuses) and the
 * promotion validator (ComponentStatusValidator#validatePliStatus) gates
 * promotion on `pliStatus == "Active"`. Only `ACTIVE` PLI configs are
 * promotable to production.
 */
export enum PLIConfigStatus {
    ACTIVE = 'Active',
    DRAFT_IN_PROGRESS = 'Draft in Progress',
    INACTIVE = 'Inactive',
}
